<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Court Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <!-- <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                      -->
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_SCHEDULE }"><a @click="onClickTabSchedule()" href="#tab_2" data-toggle="tab" aria-expanded="true">Schedule</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProjectName" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <select v-model="formData.project_id" class="form-control" :disabled="viewMode == MODE_VIEW">
                                  <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLocation" class="col-sm-4 control-label">Valid From</label>
                              <div class="col-md-8">
                                <div class="input-group">
                                  <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="valid_from" :value=formData.valid_from 
                                              :format=DATE_FORMAT :input-attr="{ 'id': 'valid_from', 'disabled': viewMode == MODE_VIEW }"
                                              :input-style="{ 'width': '100%' }"></datepicker>
                                  <span class="input-group-addon">
                                    <i class="icon ion-calendar"></i>
                                  </span>
                                </div>
                              </div>                     
                            </div>                      
                          </div>
                        </div>  
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputOcccupancy" class="col-sm-4 control-label">Occupancy</label>
                              <div class="col-md-8">
                                <input type="text" @keyup="formattingNumber($event)" ref="inputOcccupancy" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputOcccupancy" placeholder="" v-model="formData.occupancy">
                              </div>                     
                            </div> 
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputIsCheckQuota" class="col-sm-4 control-label">Checking Quota</label>
                                  <div class="col-md-8">
                                    <div class="checkbox">
                                      <label>
                                        <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputIsCheckQuota" v-model="formData.is_check_quota">
                                      </label>
                                    </div>
                                  </div>                     
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputIsCheckQuota" class="col-sm-4 control-label">Is Booking Only</label>
                                  <div class="col-md-8">
                                    <div class="checkbox">
                                      <label>
                                        <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputIsBookingOnly" v-model="formData.is_booking_only">
                                      </label>
                                    </div>
                                  </div>                     
                                </div>
                              </div>  
                            </div>   
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCategory" class="col-sm-4 control-label">Category</label>
                              <div class="col-md-8">
                                <select v-model="formData.category_id" class="form-control" :disabled="viewMode == MODE_VIEW">
                                  <option v-for="(row, i) in listCategory" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputMaxTime" class="col-sm-4 control-label">Max Time Booking</label>
                              <div class="col-md-8">
                                <input type="text" @keyup="formattingNumber($event)" ref="inputMaxTime" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputMaxTime" placeholder="" v-model="formData.max_time">
                              </div>                     
                            </div> 
                          </div>
                        </div>                                              
                      </div>
                    </div>                   
                    <div v-bind:class="{ active: tabActive == TAB_SCHEDULE }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                          <label for="recordPerPageSchedule" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                          <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                            <select v-on:change="changePageSizeSchedule" ref="recordPerPageSchedule" class="form-control">
                              <option v-if="inquiryParamSchedule.pageSize == 10" selected>10</option><option v-else>10</option>
                              <option v-if="inquiryParamSchedule.pageSize == 20" selected>20</option><option v-else>20</option>
                              <option v-if="inquiryParamSchedule.pageSize == 50" selected>50</option><option v-else>50</option>
                              <option v-if="inquiryParamSchedule.pageSize == 100" selected>100</option><option v-else>100</option>
                            </select>
                          </div>   
                          <div class="box-tools">
                            <button v-on:click="onCreateSchedule" class="btn btn-primary">Create</button>               
                          </div>                                                  
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <!-- <th style="text-align:right;">Seq. No.</th> -->
                                <th style="text-align:center;">Time</th>
                                <th style="text-align:right;">Occupancy</th>
                                <th style="text-align:center;">Deletion Flag</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listSchedule" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceSchedule + i + 1}}</td>
                                <!-- <td style="text-align:right;" nowrap>{{ row.seq_no }}</td> -->
                                <td style="text-align:center;">{{ row.schedule_time }}</td>
                                <td style="text-align:right;">{{ row.occupancy }}</td>
                                <td style="text-align:center;"><input type="checkbox" :checked= row.deletion_flag></td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.court_id }}</td>
                                <td hidden>{{ row.product_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i v-on:click="changePageSchedule(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i v-on:click="changePageSchedule(inquiryParamSchedule.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryParamSchedule.CurrentPageNumber" v-on:keyup.enter="gotoPageLog($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesSchedule }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i v-on:click="changePageSchedule(inquiryParamSchedule.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i v-on:click="changePageSchedule(totalPagesSchedule)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div>
                        </div>                        
                      </div>
                    </div> 
                  </div>
                </div>
              </div>  
              <input type="hidden" class="form-control" v-model="formData.id">                                                                   
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>                
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning pull-right">Cancel</button>    
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right" style="margin-right:15px;">Save</button>
                
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>                            
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_CREATE = 'create'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'
const TAB_SCHEDULE = 'tabSchedule'

export default {
  name: 'CourtForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_SCHEDULE: TAB_SCHEDULE,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        valid_from: '',
        project_id: 0,
        category_id: 0,
        is_check_quota: false,
        occupancy: 0,
        max_time: 0,
        is_booking_only: false
      },
      showValidFrom: true,
      listProject: null,
      listCategory: null,
      listSchedule: null,
      startSequenceSchedule: 0,
      totalRowsSchedule: 0,
      totalPagesSchedule: 0,
      inquiryParamSchedule: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'seq_no'
      },
      tabActive: '',
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.getProject()
    this.getCategory()

    if (this.viewMode !== MODE_CREATE) {
      this.getDetail()
    }
  },
  mounted() {
  },
  methods: {
    updateDateField() {
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=&PageSize=9999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          this.listProject = response.data.entity
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCategory() {
      api
        .request('Sales', 'get', '/api/ProductCategory/InquiryAll', null)
        .then(response => {
          this.listCategory = response.data.entity
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getDetail() {
      api
        .request('Reservation', 'get', '/api/Reservation/Court/' + this.formData.id, null)
        .then(response => {
          this.formData = response.data.entity

          this.updateDateField()
        })
        .catch(error => {
          let message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.valid_from = ''
      this.formData.is_check_quota = false
      this.formData.occupancy = 0
      this.formData.category_id = 0
      this.formData.max_time = 0
      this.formData.is_booking_only = false

      this.updateDateField()
    },
    onEdit(formData) {
      this.viewMode = MODE_UPDATE

      this.formData.id = formData.id
      this.formData.name = formData.name
      this.formData.valid_from = formData.valid_from
      this.formData.is_check_quota = formData.is_check_quota
      this.formData.occupancy = formData.occupancy
      this.formData.max_time = formData.max_time
      this.formData.is_booking_only = formData.is_booking_only
      this.formData.occupancy = formData.occupancy

      this.updateDateField()
    },
    onCancel() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else {
        this.getDetail()
      }
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    },
    onSave() {
      let reqData = {
        id: this.formData.id,
        name: this.formData.name,
        project_id: this.formData.project_id,
        category_id: this.formData.category_id,
        is_check_quota: this.formData.is_check_quota,
        occupancy: this.formData.occupancy,
        max_time: this.formData.max_time,
        is_booking_only: this.formData.is_booking_only,
        valid_from: $('#valid_from').val()
      }

      let status = 'success'
      let message = ''
      let method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'post'
          break
        case MODE_UPDATE:
          method = 'put'
          break
      }

      api
        .request('Reservation', method, '/api/Reservation/Court', reqData)
        .then(response => {
          let resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
          this.formData.id = resData.entity.id
        })
        .then(response => {
          this.getDetail()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewMode = MODE_VIEW
    },
    onCreateSchedule() {
      let params = {
        id: '',
        court_id: this.formData.id,
        court_occupancy: this.formData.occupancy,
        mode: MODE_CREATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'CourtScheduleForm', params: params })
    },
    onClickTabSchedule() {
      this.inquirySchedule()
    },
    inquirySchedule() {
      this.inquiryParamSchedule.WhereClause = 'court_id = \'' + this.formData.id + '\''
      api
        .request('Reservation', 'get', '/api/Reservation/Court/Schedule?WhereClause=' + this.inquiryParamSchedule.WhereClause +
                                 '&PageSize=' + this.inquiryParamSchedule.PageSize + '&CurrentPageNumber=' + this.inquiryParamSchedule.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParamSchedule.SortDirection + '&SortExpression=' + this.inquiryParamSchedule.SortExpression, null)
        .then(response => {
          this.listSchedule = response.data.entity
          this.totalRowsLog = response.data.totalRows
          this.totalPagesLog = response.data.totalPages
          this.$refs.recordPerPageSchedule.value = this.inquiryParamSchedule.PageSize
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    changePageSizeSchedule(evt) {
      this.inquiryParamSchedule.PageSize = evt.target.value
      this.inquiryParamSchedule.CurrentPageNumber = 1
      this.startSequenceSchedule = (this.inquiryParamSchedule.CurrentPageNumber - 1) * this.inquiryParamSchedule.PageSize
      // this.inquiryLog()
    },
    gotoPageSchedule(evt) {
      if (evt.target.value > this.totalPagesSchedule) {
        this.inquiryParamSchedule.CurrentPageNumber = this.totalPagesSchedule
      } else if (evt.target.value < 1) {
        this.inquiryParamSchedule.CurrentPageNumber = 1
      }
      this.startSequenceSchedule = (this.inquiryParamSchedule.CurrentPageNumber - 1) * this.inquiryParamSchedule.PageSize
      // this.inquiryLog()
    },
    changePageSchedule(page) {
      if (page < 1) {
        this.inquiryParamSchedule.CurrentPageNumber = 1
      } else if (page > this.totalPagesSchedule) {
        this.inquiryParamSchedule.CurrentPageNumber = this.totalPagesSchedule
      } else {
        this.inquiryParamSchedule.CurrentPageNumber = page
      }
      this.startSequenceSchedule = (this.inquiryParamSchedule.CurrentPageNumber - 1) * this.inquiryParamSchedule.PageSize
      // this.inquiryLog()
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// CourtForm.vue?0d452862